class EventMap {
    constructor(mapKeyFormat, events = []) {
        if (!mapKeyFormat || typeof mapKeyFormat !== 'string') {
            throw Error('EventMap instances require a map key format string in the constructor')
        }
        Object.defineProperty(this, 'mapKeyFormat', {
            value: mapKeyFormat,
            enumerable: false
        })
        Object.defineProperty(this, 'idMap', {
            value: {},
            enumerable: false
        })
        if (!(events instanceof Array)) {
            events = Object.values(events)
        } 
        events.forEach((event) => {
            this.add(event)
        })
        return this
    }

    add(event, key) {
        // find the appropriate position on the event map
        key = key ? key : event.startDate.format(this.mapKeyFormat)
        if (this.idMap[event.id] && this.idMap[event.id] !== key) {
            this.remove(event, this.idMap[event.id])
        }

        let insertIndex = -1
        if (this[key] === undefined) {
            this[key] = []
        }  else {
            insertIndex = this[key].findIndex((oldEvent) => {
                return oldEvent.startDate > event.startDate
            })
        }
        // insert the event in the right position based on chronology
        if (insertIndex === -1) {
            this[key].push(event)
        } else {
            this[key].splice(insertIndex, 0, event)
        }
        this.idMap[event.id] = key;
        return key
    }

    remove(event, key) {
        // find the appropriate position on the event map
        key = key ? key : event.startDate.format(this.mapKeyFormat)
        // remove the event from its array]
        const removeIndex = this[key].findIndex((oldEvent) => {
            return oldEvent.id === event.id
        })
        if (removeIndex === -1) {
            throw Error(`Could not find Event: ${event.id} in the map for this view!`)
        }
        this[key].splice(removeIndex, 1)
        this.idMap[event.id] = null;
        return key
    }

    getMomentFromKey(key) {
        return moment(key, this.mapKeyFormat)
    }

    getKeyFromMoment(date) {
        return date.format(this.mapKeyFormat)
    }

    static updateAllCalendarMaps(calendar, event) {
        if (!calendar || !event) {
            throw Error('You must provide a calendar or event object')
        }
        // Update on all Calendar's Views
        calendar.views.forEach(function(viewObject) {
            //reinsert back into the eventMap
            viewObject.state.eventMap.add(event)
        })
    }
}

export default EventMap;